import { useQuery } from '@tanstack/react-query';
import { apiUrlGenerator } from 'infrastructure/hooks/use-api';
import dataService from 'services/dataService';

import type { IProviderDashboardCcmDetails } from 'components/organisms/provider-dashboard';

export interface IGetProviderDashboardCcmDetailsFilters {
  startDate: string;
  endDate: string;
  clinicGuid?: string[];
  parentClinicGuid?: string[];
  providerGuid?: string;
}

const url = 'core-2/provider-dashboard/ccm-details';

export const getProviderDashboardCcmDetailsQueryKey = (
  filters: IGetProviderDashboardCcmDetailsFilters,
) => [url, filters] as const;

const queryFn = async (filters: IGetProviderDashboardCcmDetailsFilters) => {
  const { data, error } =
    await dataService.getList<IProviderDashboardCcmDetails>(
      apiUrlGenerator(url, filters),
    );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useGetProviderDashboardCcmDetails = (
  filters: IGetProviderDashboardCcmDetailsFilters,
  enabled = true,
) => {
  const queryKey = getProviderDashboardCcmDetailsQueryKey(filters);

  const { data, isLoading, isFetching } = useQuery<
    IProviderDashboardCcmDetails | undefined,
    string | undefined
  >({
    queryKey,
    queryFn: async () => queryFn(filters),
    keepPreviousData: true,
    enabled,
  });

  return {
    ccmDetails: data,
    isLoading,
    isFetching,
  };
};
